var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarShop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.243 6.96C3.09.95 3.012 1.107 3.016 1.107A1.946 1.946 0 014.766 0h12.467c.745 0 1.432.435 1.75 1.107.005 0-.075-.159 2.774 5.853a2.498 2.498 0 01-1.589 3.476v5.956a1.939 1.939 0 01-1.937 1.937h-6.327v1.864h3.687a.904.904 0 110 1.807H6.41a.904.904 0 110-1.807h3.687v-1.864H3.77a1.939 1.939 0 01-1.937-1.937v-5.956A2.498 2.498 0 01.242 6.96zm9.853-5.153H8.483L7.156 6.846a1.494 1.494 0 102.94.38V1.807zm1.808 5.419c0 1.426 1.813 2.034 2.678.912.285-.37.38-.84.262-1.292l-1.327-5.039h-1.613v5.419zm8.22.507c-2.8-5.905-2.778-5.856-2.774-5.852a.13.13 0 00-.117-.074h-1.847l1.527 5.799a1.495 1.495 0 001.445 1.114H19.5a.69.69 0 00.624-.987zM3.768 16.521H18.23a.13.13 0 00.13-.129c0-6.144.002-5.865-.003-5.865a3.303 3.303 0 01-2.479-1.122A3.3 3.3 0 0111 9.49a3.3 3.3 0 01-4.879-.086 3.303 3.303 0 01-2.48 1.122c-.004 0-.002-.278-.002 5.865 0 .072.058.13.13.13zM2.5 8.72h1.14c.679 0 1.273-.458 1.446-1.114l1.526-5.799H4.767a.13.13 0 00-.117.074c.004-.004.012-.026-2.774 5.852a.69.69 0 00.625.987z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarShop);
export default __webpack_public_path__ + "static/media/navbar_shop.90d7f3feaeb7aa3a42f5d23988269795.svg";
export { ForwardRef as ReactComponent };